import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { filter, map, Observable, Subscription, switchMap, take } from 'rxjs';
import { getAccountState, getBonusPointsState, getCustomerConfigState, getMenuListState } from '../../../redux/reducers';
import { IAccountModel } from '../../../redux/models/loyalty/IAccount.model';
import * as AccountAction from '../../../redux/actions/loyalty/actions-account';
import * as BonusPointsAction from '../../../redux/actions/loyalty/actions-bonus-points';
import { BonusPointsState } from '../../../redux/models/loyalty/bonus-points.state';
import { BackendService } from '../../../redux/services/backend.service';
import { isOn } from 'feature-toggle-service';
import { customerConfig, LoyaltyMenuFilterService, LoyaltySsoService } from '@uxdf/direct-shared-lib';
import { FilteredMenuList } from '../../homepage/homepage-layout/menu-item.model';
import { AccountState } from '../../../redux/models/loyalty/account.state';
@Component({
  standalone: false,
  selector: 'app-loyalty-bonus-points',
  templateUrl: './loyalty-bonus-points.component.html',
  styleUrls: ['./loyalty-bonus-points.component.scss']
})
export class LoyaltyBonusPointsComponent implements OnInit, OnDestroy {
  // @loyaltyDocs: loyalty-bonus-points component
  // page displays bonus points

  readonly loyaltyInnerPageFindPointsStatusString = $localize`:@@loyalty-bonus-points.loyaltyInnerPageFindPointsStatus:
  Find here your points status. Your membership ID`;
  readonly loyaltyErrorInformationNotAvaiableString = $localize`:@@loyalty-bonus-points.loyaltyErrorInformationNotAvaiable:
  Sorry, we do not have access to your Amadeus+Me information right now. Please come back later.`;
  readonly accountFirstSegmentsString = $localize`:@@loyalty-bonus-points.accountFirstSegments:Segments`;
  readonly youHaveConstantString = $localize`:@@loyalty-request-tile.loyaltyRequestTileYouHave:You have`;
  readonly pointsExpiryString = $localize`:@@loyalty-request-tile.loyaltyRequestTileWillExpire:points which will expire on`;
  readonly gmtConstantString = $localize`:@@loyalty.loyaltyRequestTileAtGmt:at 23:59 (GMT)`;
  readonly cronGenericFailureString = $localize`:@@loyalty.loyaltyCronFailed:Unable to retrieve. You can calculate them manually in the Status points section.`;
  readonly expiringConstantString = $localize`:@@loyalty-bonus-points.loyaltyPointsExpiring:Points expiring on`;
  readonly goToGiftCatalogString = $localize`:@@loyalty-bonus-points.loyaltyMenuGiftCatalogue:Gift catalog`;

  giftCatalogTitle: string = this.goToGiftCatalogString;
  isSnow = false;

  isAccountEnabled = false;
  reportLink = '#';
  pointsReport = 'pointsReportLink';

  bonusPointsState$: Observable<BonusPointsState>;
  enablePointBalanceBannerTile = isOn('AD_POINT_BALANCE_BANNER_E');
  lastDayOfMonth = new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0);
  expirationPointsEnabledForMarket = false;

  private readonly accountSubscription: Subscription;
  private customerConfigSubscription: Subscription;
  filteredMenuList: FilteredMenuList = { navigation: [] };

  constructor(
    private readonly store: Store<any>,
    private readonly router: Router,
    private readonly backendService: BackendService,
    private readonly loyaltySsoService: LoyaltySsoService,
    private readonly menuFilterService: LoyaltyMenuFilterService
  ) {
   this.accountSubscription = this.store.pipe(
      select(getAccountState),
      filter((response: AccountState) => !response.isLoading)
    ).subscribe((response: AccountState) => {
      if (+response.agentNumber !== 0) {
        this.isAccountEnabled = true;
      } else {
        console.warn('[LoyaltyBonusPointsComponent] No loyalty account found, redirecting to enrollment page');
        this.router.navigate(['/amadeus-plus-me/enrollment']);
      }
    });

    this.customerConfigSubscription = this.store.pipe(select(getCustomerConfigState)).subscribe(response => {
      if (response.customerConfig && !response.isLoading) {
        this.store.dispatch(new AccountAction.GetAccount());
        this.store.dispatch(new BonusPointsAction.GetBonusPoints());
      }
    });

    this.bonusPointsState$ = this.store.pipe(select(getBonusPointsState));

    this.backendService.getModularityConfig().subscribe(response => {
      this.expirationPointsEnabledForMarket = response?.loyalty?.enabled_for_monthly_expiration_points;
    });
  }
ngOnInit() {
this.store
  .pipe(
    select(getMenuListState),
    filter(menu => !menu.isLoading),
    map(menu => menu.menuList),
    take(1),
    switchMap(menuList => this.menuFilterService.execute(menuList))
  )
  .subscribe(filteredMenuList => {
    if (filteredMenuList && filteredMenuList.navigation) {
      const amadeusItem = filteredMenuList.navigation.find(item => item.code === 'amadeus-plus-me');
      this.giftCatalogTitle = amadeusItem?.children?.find(child => child.code === 'amadeus-plus-me-gift-catalog')?.title || this.goToGiftCatalogString;
    } else {
      this.giftCatalogTitle = this.goToGiftCatalogString;
    }
  });

  this.customerConfigSubscription = this.store.pipe(
        select(customerConfig)).subscribe(response => {
            this.isSnow = response.customerConfig.is_snow;
        });
}

  ngOnDestroy() {
    if (this.accountSubscription && !this.accountSubscription.closed) {
      this.accountSubscription.unsubscribe();
    }
    if (this.customerConfigSubscription && !this.customerConfigSubscription.closed) {
      this.customerConfigSubscription.unsubscribe();
    }
    if (this.customerConfigSubscription) {
      this.customerConfigSubscription.unsubscribe();
    }
  }

  redirectToOrderGifts() {
    window.parent.postMessage('Oneportal-PlusMe-GiftNav', '*');
    this.loyaltySsoService.openLink('amadeus-plus-me-gift-catalog');
  }
}
